import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { Form } from '@/common/form/Form';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/MainBox';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { McdInvStatusDefinitionsDialog } from '@/sc/entities/mcdInv/dashboard/McdInvStatusDefinitionsDialog';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, FormControl, InputLabel, MenuItem, Select, styled } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { McdInvDashboardMapView } from './views/McdInvDashboardMapView';
import { McdInvDashboardOperationsView } from './views/McdInvDashboardOperationsView';

export const McdInvDashboard = () => {

  const rsrc = useRsrc();
  const { navState } = useNavState();

  const { openDialog } = useDialog();

  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');
  const defaultFormValues = useRef();

  const [endDateToStartDate, setEndDateToStartDate] = useState();
  const [idToMcdInvOrigin, setIdToMcdInvOrigin] = useState();

  const views = ['Operations', 'Map'];
  const viewToComponent = {
    Operations: McdInvDashboardOperationsView,
    Map: McdInvDashboardMapView,
  };
  const [view, setView] = useState('Operations');

  useEffect(() => {
    rsrc.data('sc', 'MCD_INV_DASHBOARD_FILTERS_DATA_PLUGIN', {}).then(res => {
      setFieldDefs([
        { field: 'invPeriodId', displayName: 'Invoice Period', type: 'DROPDOWN', values: res.periods },
        { field: 'stateIds', displayName: 'States', type: 'TREE', treeData: res.stateTreeData },
        { field: 'ctrtIds', displayName: 'Contracts', type: 'TREE', treeData: res.ctrtTreeData },
        { field: 'checkRunDates', displayName: 'Check Run Dates', type: 'TREE', treeData: res.checkRunDateTreeData },
        { field: 'mcdInvOriginIds', displayName: 'Mcd Inv Origin', type: 'TREE', treeData: res.mcdInvOriginTreeData }
      ]);

      setEndDateToStartDate(res.endDateToStartDate);
      setIdToMcdInvOrigin(res.idToMcdInvOrigin);

      defaultFormValues.current = {
        invPeriodId: res.periods[0]?.value,
        stateIds: res.stateIds,
        ctrtIds: res.ctrtIds,
        checkRunDates: res.checkRunDates,
        mcdInvOriginIds: res.mcdInvOriginIds
      };

      if (!navState.formValues) {
        setFormValues(defaultFormValues.current);
      }

    });
  }, []);

  const openDefinitionsDialog = () => {
    openDialog(McdInvStatusDefinitionsDialog)
  }

  const ViewComponent = viewToComponent[view];

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      {/* Title */}
      <Title 
        icon={fas.faTasks} 
        title="Medicaid Invoice Dashboard" 
        buttons={[
          <FormControl key="viewSelect" fullWidth sx={{ minWidth: 200 }}>
            <InputLabel>View</InputLabel>
            <Select value={view} label="View" onChange={(event) => setView(event.target.value)}>
              {views.map((view) => (
                <MenuItem key={view} value={view}>
                  {view}
                </MenuItem>
              ))}
            </Select>
          </FormControl>,
          <TitleButton
            key="comparePolFormulaButton"
            icon={fas.faInfoCircle}
            toolTip="View Definitions"
            onClick={openDefinitionsDialog}
          />,
        ]}
      />

      {/* Filters */}
      <Form fieldDefs={fieldDefs} formValues={formValues} setFormValues={setFormValues} container={FilterContainer} />

      <ViewComponent
        formValues={formValues}
        endDateToStartDate={endDateToStartDate}
        idToMcdInvOrigin={idToMcdInvOrigin}
      />

    </ContentBox >
  );
};

const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
  
}));